import { GridActionsCellItem } from "@mui/x-data-grid";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

export const AdminTradeColumns = (handleRemove) => [
  {
    field: "trade_id",
    headerName: "Trade ID",
    width: 100,
    headerAlign: "center",
    align: "center",
    editable: false,
  },
  {
    field: "user_id",
    headerName: "User ID",
    width: 100,
    headerAlign: "center",
    align: "center",
    editable: false,
  },
  {
    field: "username",
    headerName: "Username",
    width: 150,
    headerAlign: "center",
    align: "center",
    editable: false,
  },
  {
    field: "trade_date",
    headerName: "Trade Date",
    editable: true,
    width: 150,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "notes",
    headerName: "Notes",
    editable: true,
    flex: 1,
    headerAlign: "center",  // header centered
    align: "left",          // cell left-aligned
  },
  {
    field: "is_flagged",
    headerName: "Flagged",
    editable: true,
    type: "boolean",
    width: 100,
    headerAlign: "center",
    align: "center",
    cellClassName: (params) => (params.row._edited?.includes("is_flagged") ? "edited-cell" : ""),
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 50,
    headerAlign: "center",
    align: "center",
    getActions: (params) => [
      <GridActionsCellItem
        icon={
          <RemoveCircleOutlineIcon
            sx={{ color: "#d32f2f", mx: "auto" }}
            fontSize="small"
          />
        }
        label="Remove"
        onClick={() => handleRemove(params.id)}
      />,
    ],
  },
];
